import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, Pagination as Pagination$1 } from "@wsui/base";
import { useCallback } from "react";
import { usePagination } from "react-instantsearch-hooks";
function Pagination(props) {
  props = useThemeProps({
    props,
    name: "AlgoliaPagination"
  });
  const {
    // pages,
    currentRefinement,
    // nbHits,
    nbPages,
    // isFirstPage,
    // isLastPage,
    canRefine,
    refine
    // createURL,
  } = usePagination(props);
  let {
    showFirstButton = false,
    showLastButton = false,
    showPrevButton = false,
    showNextButton = false,
    showLabels = false,
    ...restProps
  } = props;
  const handleChange = useCallback((_, page) => {
    refine(page);
    window.scrollTo(0, 0);
  }, []);
  if (!canRefine) {
    return null;
  }
  return /* @__PURE__ */jsx(Pagination$1, {
    page: currentRefinement,
    count: nbPages,
    showFirstButton,
    showLastButton,
    hidePrevButton: !showPrevButton,
    hideNextButton: !showNextButton,
    showLabels,
    onChange: handleChange,
    ...restProps
  });
}
export { Pagination as default };